// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"bcb783f06d2a356e","5285":"6f47132c14924b0a"}[chunkId] + ".css";
};